// extracted by mini-css-extract-plugin
export default {"tariffs":"TariffChoiceList_tariffs__D0mqK","tariffsItem":"TariffChoiceList_tariffsItem__9s4U9"};